import { gql } from "@apollo/client";

export const GET_DEBIT_CARD_INVITES = gql`
  query SpendDebitCardInvites($groupId: String) {
    spendDebitCardInvites(groupId: $groupId) {
      count
      invites {
        firstName
        lastName
        userId
        groupId
        organizationId
      }
    }
  }
`;
